import { render, staticRenderFns } from "./point.vue?vue&type=template&id=7e3842c0&scoped=true&"
import script from "./point.vue?vue&type=script&lang=js&"
export * from "./point.vue?vue&type=script&lang=js&"
import style0 from "./point.vue?vue&type=style&index=0&id=7e3842c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3842c0",
  null
  
)

export default component.exports